<template>
    <div class="vant-card">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了"  @load="onLoad" >
            <van-cell-group>
                    <van-field v-model="dataFrom.id" label="订单号" placeholder="订单号" />
                </van-cell-group>
            <mt-button type="primary" size="large" @click="handleSearch" style="margin-bottom:22px">搜索</mt-button>
            <div class="content" v-for="item in dataList" :key="item.id">
                <div class="vant-v" >
                    <van-row>
                        <van-col span="18">账户余额：<span style="color:#00A600;"> ¥{{item.accountBalanceRmb}}</span></van-col>
                        <van-col span="6">{{item.ioTypeName}}</van-col>
                    </van-row>
                    <van-row>
                        <van-col span="8">交易金额：<span style="color:#FE3B30;"> ¥{{item.amountRmb}}</span></van-col>
                        <van-col span="8"></van-col>
                        <van-col span="8">卡号：{{item.iccid}}</van-col>
                    </van-row>
                </div>
            </div>
        </van-list>
        <van-overlay :show="isShow" @click="isShow = false">
            <div class="overlay" @click.stop>
                <div class="title">
                    <van-row>
                        <van-col span="10">编辑套餐信息</van-col>
                        <van-col span="14"><van-icon name="close"  @click="isShow = false" /></van-col>
                    </van-row> 
                </div>
                <van-row>
                    <van-col span="8">套餐名称</van-col>
                    <van-col span="16">{{form.packageName}}</van-col>
                </van-row>
                  <van-row>
                    <van-col span="8">套餐成本价</van-col>
                    <van-col span="16">{{form.verifyPriceRmb}}</van-col>
                </van-row>
                <van-row>
                    <van-col span="8">状态</van-col>
                    <van-col span="16">{{form.stateName}}</van-col>
                </van-row>
                 <van-row>
                    <van-col span="8">套餐售价</van-col>
                    <van-col span="16">
                        <input v-model="form.salePriceRmb" />
                    </van-col>
                </van-row>
                 <mt-button type="primary" size="large" @click="agentLoginHandler">修改</mt-button>
            </div>
        </van-overlay>
    </div>
</template>
<script>
import { Toast } from 'vant';
import { wxRequest} from '@/api/agent.js'
export default {
    name:'card',
    data(){
        return{
            dataFrom:{},
            isShow:false,
            pageNo: 0,
            perPageNum: 10,
            allPage:0,
            pickerName:'',
            columns: [],
            form:{},
            dataList:[],
            showPicker: false,
            pickerName1:'',
            columns1: [],
            finished:false,
            loading:false,
            showPicker1: false,
        }
    },
    created(){
        // this.getSimDistributRecordHandler();
        this.getSelect();
    },
    methods:{
        getSelect(){
            // 获取代理商数据
            wxRequest('/agent/list', {}, 'post').then(res => {
                if(res.data.code === '200'){
                    if(Array.isArray(res.data.data) && res.data.data.length>0){
                        res.data.data.forEach(item=>{
                            this.columns.push({id:item.id,text:item.name})
                        })
                    }
                }else{
                    this.$messagebox.alert(res.data.message)
                }
            })
             // 获取套餐数据
            wxRequest('sim/search/allow/pkgGroup', {}, 'get').then(res => {
                if(res.data.code === '200'){
                    if(Array.isArray(res.data.data) && res.data.data.length>0){
                        res.data.data.forEach(item=>{
                            this.columns1.push({id:item.id,text:item.name})
                        })
                    }
                }else{
                    this.$messagebox.alert(res.data.message)
                }
            })
        },
        // 初始化数据
        getSimDistributRecordHandler(){
            var data = {
                pageNo: this.pageNo,
                agentId:this.dataFrom.agentId,
		        pkgGroupId:this.dataFrom.pkgGroupId,
                perPageNum: this.perPageNum,
                id:this.dataFrom.id
            }
            wxRequest("agent/account/flow/list1", data, "post").then(res => { 
                if(res.data.code == 200){
                    this.loading = false;
                    if(res.data.data.totalNum === 0){
                        this.finished = true;
                        return
                    }
                    this.allPage = Math.ceil(res.data.data.totalNum / this.perPageNum)
                    if(this.pageNo == this.allPage){
                        this.finished = true;
                    }
                    this.dataList = this.dataList.concat(res.data.data.resultList)
                }else{
                    this.$messagebox.alert(res.data.message)
                }
            })
        },
        //分销
        distribution(packageId){
           var data = {
                id:packageId
            }
            wxRequest("pkg/sold/state", data, "post").then(res => { 
                if(res.data.code == 200){      
                    this.$messagebox.alert(res.data.message)      
                    this.handleSearch()
                }else{
                    this.$messagebox.alert(res.data.message)
                }
            })
        },
        //移除
        remove(packageId,nextId){
           var data = {
                nextId:nextId,
                packageId: packageId,
                agentId:this.dataFrom.agentId
            }
            wxRequest("pkg/sold/cancel", data, "post").then(res => { 
                if(res.data.code == 200){      
                    this.$messagebox.alert(res.data.message)      
                    this.handleSearch()
                }else{
                    this.$messagebox.alert(res.data.message)
                }
            })
        },
        // 显示编辑弹窗
        edit(data){
            this.isShow = true
            this.form=data
        },
        //保存编辑
        agentLoginHandler(packageId,nextId){
           var data = {
                id: this.form.id,
                salePriceRmb:this.form.salePriceRmb
            }
            wxRequest("pkg/sold/updatePrice", data, "post").then(res => { 
                if(res.data.code == 200){     
                    this.isShow=false 
                    this.$messagebox.alert(res.data.message)      
                    this.handleSearch()
                }else{
                    this.$messagebox.alert(res.data.message)
                }
            })
        },
        onLoad(){
            if(this.finished) return
            this.pageNo++
            this.loading = true;
            this.getSimDistributRecordHandler()
        }, 
        // 查询
        handleSearch() {
            this.pageNo = 1
            this.dataList = []
            this.getSimDistributRecordHandler()
        },
        onConfirm(value) {
            this.pickerName = value.text
            this.dataFrom.agentId = value.id
            this.showPicker = false;
        },
        onConfirm1(value) {
            this.pickerName1 = value.text
            this.dataFrom.pkgGroupId = value.id
            this.showPicker1 = false;
        },
        onCancel() {
             this.showPicker = false;
        },
        onCancel1() {
             this.showPicker1 = false;
        },
    }
}
</script>
<style lang="less" scoped>
    .van-cell:not(:last-child)::after{
        border:0
    }
    .vant-card{
        min-height:100%;
        background: #F5F5F5;
        padding-top: 10px;
        .dataFrom{
            margin:0px 14px 16px 14px;
            padding:8px;
            padding-left:16px;
            padding-right:16px;
            border-radius: 8px;
            background: #fff;
            [class*=van-hairline]::after{
                border:0
            }
            .van-cell{
                padding-bottom:13px;
                padding-top: 16px;
                padding-right: 0;
                :not(:last-child)::after{
                     border:0
                }
            }
            .ksea{
                /deep/.van-cell__value{
                    .van-field__control{
                        background: url(./../../assets/agent/icon5.png) no-repeat right center;
                        background-size:13px 8px ;
                    }
                }
            }
            .van-cell-group{
                /deep/.van-cell__title{
                    color:#000;
                }
                /deep/.van-cell__value{
                    .van-field__control{
                        line-height: 24px;
                    }
                }
            }
        }
        button{
            margin: 16px 14px 0 14px;
            width: calc(100% - 28px);
            font-size:14px;
            background:#1677FE;
            border-radius:8px;
            height:48px;
        }
        .content{
            margin-top:10px;
            margin-left:14px;
            margin-right:14px;
            background:#fff;
            padding:16px;
            border-radius:8px;
            .vant-v{
                .van-row{
                    padding-bottom:8px;
                    .van-col--18{
                        color:#000;
                        font-size:14px;
                    }
                    .van-col--6{
                        color:#1677FE;
                        font-size:14px;
                        text-align:right;
                    }
                    .van-col--8{
                        color:#999;
                        font-size:12px;
                        margin-top:6px;
                    }
                }
                .vant-btn{
                    display: flex;
                    justify-content: flex-end;
                    button{
                        border-radius:18px;
                        width:70px;
                        height:36px;
                        background:#fff;
                        color:#1677FE;
                        border:1px solid #1677FE;
                        margin: 0;
                        margin-left:10px;
                    }
                }
            }
        }
    }
    .overlay{
        background: #fff;
        width: 90%;
        margin: auto;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        height:370px;
        .van-row{
            padding:16px;
            border-bottom: 1px solid #F4F4F4;
            .van-col--16{
                color: #171717;
                text-align: right;
            }
            .van-col--8{
                color: #333;
            }
        }
        .title{
            .van-col--10{
                font-size:16px;
                color: #000;
                font-weight:bold;
            }
            .van-col--14{
                text-align: right;
                .van-icon{
                    font-size:16px;
                }
            }
        }
        .van-row:nth-child(6){
            border-bottom:0;
        }
    }
</style>